export const config = {
  title: "A One Limo Inc | Premier Limousine Services in Belleville, MI",
  meta: {
    description:
      "A One Limo Inc offers top-notch limousine and transportation services in Belleville, MI, providing a luxurious fleet and professional chauffeurs for all occasions.",
    keywords: [
      'Limousine Service Belleville',
      'A One Limo Inc',
      'Detroit Limo Services',
      'Party Bus Rental',
      'Wedding Transportation',
      'Airport Transfers Detroit',
      'Prom Limo Service',
      'Corporate Transportation',
      'Belleville MI Limos',
      'Luxury Car Service',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "A One Limo Inc",
    canonicalUrl: 'https://aonelimo.com/',
  },
  sections: {
    header: {
      businessName: "A One Limo Inc",
    },
    sectionB: {
      heroTitle: "A One Limo Inc",
      heroSubtitle: 'Premier Limousine Services in Belleville, MI',
      learnAboutText: 'Discover Our Fleet',
      phoneNumber: '+17343979700',
      phoneLabel: '(734) 397-9700',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/2147522695/photo/professional-chauffeur-opening-luxury-car-door-for-service.jpg?s=612x612&w=0&k=20&c=a-vEarLqJjqpzFr-aXViQzzIYgq67501IvJ-iXP2Xzw=',
      cardData: [
        {
          title: 'Mission',
          description:
            'At A One Limo Inc, our mission is to provide exceptional limousine and transportation services, ensuring comfort, safety, and luxury for every client.',
        },
        {
          title: 'Vision',
          description:
            'To be the leading limousine service provider in the Detroit Metro Area, recognized for our commitment to excellence, diverse fleet, and professional chauffeurs.',
        },
        {
          title: 'Why Choose Us',
          description:
            'With over 25 years of experience, a diverse fleet of well-maintained vehicles, and a team of licensed, friendly drivers, we offer customizable limo packages to suit any occasion.',
        },
      ],
      description:
        "A One Limo Inc specializes in providing luxurious transportation solutions for weddings, proms, corporate events, and special occasions. Our fleet includes party buses, stretch limousines, SUVs, and sedans, all equipped with premium amenities to ensure a memorable experience.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Explore our range of professional limousine services designed to make your events unforgettable.",
      cards: [
        {
          title: 'Party Bus Service',
          description:
            "Our spacious party buses are perfect for large groups, offering state-of-the-art sound systems, ambient lighting, and ample seating to keep the party going on the road.",
          imageSrc:
            'https://aonelimo.com/wp-content/uploads/2015/11/Giant-Luxury-Bus.jpg',
          imageAlt: 'Party Bus Service'
        },
        {
          title: 'Wedding Transportation',
          description:
            "Make your special day seamless with our elegant wedding transportation services, ensuring timely and stylish arrivals for you and your guests.",
          imageSrc:
            'https://media.istockphoto.com/id/522315131/photo/wedding-limousine-with-ex-court.jpg?s=612x612&w=0&k=20&c=niCxaJmD_HxzMnWMEyKLKb92NWSAMjKTxKYzbLbxMwE=',
          imageAlt: 'Wedding Transportation',
        },
        {
          title: 'Sporting or Concert Events',
          description:
            "Arrive at your favorite sporting event or concert in style and comfort with our premium limousine services. Avoid the hassle of parking and traffic while enjoying a luxurious, stress-free ride with your group.",
          imageSrc:
            'https://aonelimo.com/wp-content/uploads/2015/11/Black-Luxury-Bus.jpg',
          imageAlt: 'Sporting or Concert Event Transportation',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Special Event Transportation',
        'Proms',
        'Bachelor/Bachelorette Party',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://aonelimo.com/wp-content/uploads/2018/11/Black-Cadillac-Limousine-04.jpg',
        alt: "A One Limo Inc Team",
      },
      aboutText: [
        "With a rich history spanning over 25 years, A One Limo Inc has been a cornerstone in providing premium limousine services in Belleville, MI, and the greater Detroit area. Our commitment to excellence is reflected in our meticulously maintained fleet and our professional, courteous chauffeurs.",
        "Whether it's a night out, a corporate event, or your wedding day, we strive to deliver an unparalleled transportation experience, tailored to meet your specific needs and preferences.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "A One Limo Inc",
      businessName: "A One Limo Inc",
      contact: {
        phone: '+17343979700',
        phoneLabel: '(734) 397-9700',
        email: 'aonelimo@gmail.com',
        website: 'https://aonelimo.com/',
        address: '7891 Haggerty Rd, Belleville, MI 48111',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: 'https://twitter.com/aonelimo1',
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '7891 Haggerty Rd, Belleville, MI 48111',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2949.1234567890123!2d-83.45678901234567!3d42.12345678901234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x883b1234567890ab%3A0xcdef1234567890ab!2s7891%20Haggerty%20Rd%2C%20Belleville%2C%20MI%2048111%2C%20USA!5e0!3m2!1sen!2sph!4v1700000000000!5m2!1sen!2sph',
    },
  },
};

export default config;
